import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';


export const AlbumInsert = createAsyncThunk(
    '/AlbumInsert',
    async (data) => {
        let url = baseUrl+'InsertAlbum';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
     
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const photoInsert = createAsyncThunk(
    '/photoInsert',
    async (data) => {
        let url = baseUrl+'Insertphoto';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
     
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
 
  export const videoInsert = createAsyncThunk(
    '/videoInsert',
    async (data) => {
        let url = baseUrl+'Insertvideo';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
     
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const MediaGet = createAsyncThunk(
    '/MediaGet',
    async (data) => {
        let url = baseUrl+'MediaGet';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
     
        
        if(response.status === "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const MediaDelete = createAsyncThunk(
    '/MediaDelete',
    async (data) => {
        let url = baseUrl+'Mediadelete';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
     console.log(response,"response")
        if(response.status == "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const albumGet = createAsyncThunk(
    '/albumGet',
    async (data) => {
        let url = baseUrl+'AlbumGet';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
   
        if(response.status == "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const Updatealbum = createAsyncThunk(
    '/Updatealbum',
    async (data) => {
        let url = baseUrl+'updateAlbum';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
       console.log(response,"response")
        if(response.status == "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const deleteUpdate = createAsyncThunk(
    '/deleteUpdate',
    async (data) => {
        let url = baseUrl+'deleteAlbum';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
       console.log(response,"response")
        if(response.status == "success"){

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );
 



  


  